import { MultiSelectDay } from './MultiSelectDay'
import { withMultiSelectDay } from './withMultiSelectDay'

const ConnectedMultiSelectDay = withMultiSelectDay(MultiSelectDay)

export { ConnectedMultiSelectDay as MultiSelectDay }
